$(document).ready(function () {
    $(".other-colours").slick({
        slidesToShow: 6,
        slidesToScroll: 1,
        lazyLoad: 'ondemand',
        arrows: true,
        infinite: false,
        settings: "unslick",
        responsive: [
            {
                breakpoint: 1024,
                settings: "unslick"

            }
        ]

    });

    $('.other-colours-item').on('click',function (e){
        e.preventDefault();

        var item = $(this);
        
        if($(this).attr("href") !== '#')
        {
            window.dataLayer = window.dataLayer || [];
            dataLayer.push({
                'Category': 'Product Detail Page', 
                'Action': item.data('variant-title'),
                'Label': item.data('product-name') + ' ' + item.data('variant-name'), 
                'noninteraction': true,
                'event': 'gaEvent'
            });
        }

        window.location.href = $(this).attr("href");
    });
})